module.exports = __webpack_public_path__ + "static/media/24UHCHR17.13f67008.jpg";